import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message, Space, Image, Tag, notification, Drawer } from 'antd';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LoadingOutlined } from '@ant-design/icons';
import PrimaryButton from '../Buttons/PrimaryButton';

import {
  createApplication,
  getUserDetailsById,
  updateMarketplaceUserDetails,
} from '../../services/API/MarketplaceService';
import { getClientIcon } from '../../utils/MarketplaceUtils';
import { Navigation } from '../../services/NavigationService';
import { Routes } from '../../constants/RouterConstants';
import BottomButton from '../Buttons/BottomButton';
import useMoengage from '../../hooks/useMoengage';
import { useMitraStore } from '../../contexts/MitraContext';
import moment from 'moment';
import { logFirebaseEvent } from '../../Firebase';
import { useTranslation } from 'react-i18next';
// import blitz from 'blitzllama-js';

const JobFormHeader = ({ jobData }) => {
  const [clientIcon, setClientIcon] = useState('');

  useEffect(() => {
    setClientIcon(getClientIcon(jobData.companyName));
  }, [jobData]);

  return (
    <div style={{ display: 'flex' }}>
      <img src={clientIcon} alt={jobData.companyName} style={{height:'50px'}}/>
      <div style={{ display: 'flex', flexDirection: 'column', marginTop: '0', gap: '0.3em' }}>
        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '0' }}>
          <span style={{ marginLeft: '10px', fontSize: '1em', fontWeight: 'bold' }}>
            {jobData.displayName ? jobData.displayName : jobData.companyName}
          </span>
          <JobType jobData={jobData} />
        </div>
        <span style={{ marginLeft: '10px', color: '#777777', fontSize: '12px', fontSize: '0.9em' }}>
          {jobData.jobType} Partner
        </span>
      </div>
    </div>
  );
};

const JobForm = ({ jobData, close, showGetStartedPopup, setSiId, showDuplicateApplicationPopup }) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [userFullName, setUserFullName] = useState('');
  const [dlNumber, setDlNumber] = useState('');
  const [userNewFullName, setUserNewFullName] = useState('');
  const [disableButton, setDisableButton] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const { selectedMitraDetails } = useMitraStore();
  const {t, i18n} = useTranslation();
  const [, trackEvent] = useMoengage();
  const onFinish = () => {
    message.success('Submit success!');
  };
  const onFinishFailed = () => {
    message.error('Submit failed!');
  };
  const jobId = jobData.id;
  const userId = localStorage.getItem('userId');
  const applyJob = () => {
    trackEvent('jse_clicked_continue_on_applied_jobs', 
    { 
      userId: localStorage.getItem('userId'), 
      jobId: jobId, companyName: jobData.companyName, 
      userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
      timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
    });
    setDisableButton(true); // disabling button once clicked
    setButtonLoading(true);
    if (userNewFullName && userNewFullName.trim() !== '' && userNewFullName.length > 0) {
      const splitName = userNewFullName.trim().split(' ');
      const firstName = splitName[0];
      const lastName = splitName.length > 1 ? splitName.slice(1, splitName.length).join(' ') : '';
      updateMarketplaceUserDetails({
        userId,
        dataToUpdate: { name: `${firstName} ${lastName}` },
      }).catch(error => {
        console.log(error);
      });

      const requestPayload = {
        userId,
        jobDemandId: jobId,
      };

      if (jobData.companyName.toLowerCase() === 'uber') {
        requestPayload.DLNumber = dlNumber.trim();

        if (
          !requestPayload?.DLNumber ||
          requestPayload?.DLNumber === '' ||
          requestPayload?.DLNumber.length !== 15
        ) {
          notification.error({
            message: t('dl_incorrect_error'),
          });
          setDisableButton(false);
          setButtonLoading(false);
          return;
        } else {
          trackEvent('jse_apply_job_card_dl_entered', 
          { 
            userId: localStorage.getItem('userId'), 
            jobId: jobId, companyName: jobData.companyName, 
            userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
            timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
          });
        }
      }

      createApplication(requestPayload)
        .then(response => {
          // blitz.triggerEvent('jse_job_applied');
          if (response.status !== 200) {
            toast.error(t('something_went_wrong'), {
              position: toast.POSITION.TOP_CENTER,
            });
            setDisableButton(false);
            setButtonLoading(false);
          } else {
            return response.data;
          }
        })
        .then(responseObj => {
          trackEvent('jse_apply_job_card_name_entered', 
          { 
            userId: localStorage.getItem('userId'), 
            jobId: jobId, companyName: jobData.companyName, 
            userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
            timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
           });

           logFirebaseEvent('jse_job_applied', {
            userId: localStorage.getItem('userId'), 
            jobId: jobId, companyName: jobData.companyName, 
            userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
            timeStamp: moment().format('MM/DD/YYYY HH:mm:ss')
           });

          setSiId(responseObj?.id);
          // showGetStartedPopup();

          // const route = {
          //   pathname: Routes.APPLICATION_STATUS,
          //   search: `applicationId=${responseObj?.id}`,
          // };
          // history.replace(`/application-status?applicationId=${responseObj?.id}`);
          history.replace(`/successfully-applied?applicationId=${responseObj?.id}&companyName=${jobData?.companyName}`)
          setButtonLoading(false);
          setDisableButton(false);
          // Navigation.push(route);
        })
        .catch(error => {
          setButtonLoading(false);
          setDisableButton(false);
          // notification.error({
          //   message: 'Application has already been created for this Job !',
          // });
          close();
          showDuplicateApplicationPopup()
          console.log(error);
        });
    } else {
      notification.error({
        message: t('enter_name_error'),
      });
      setButtonLoading(false);
      setDisableButton(false);
    }
  };

  const handleChange = e => {
    setUserNewFullName(e.target.value);
  };

  const handleDLNumberChange = e => {
    setDlNumber(e.target.value);
  };

  useEffect(() => {
    getUserDetailsById(userId)
      .then(response => {
        if (response.status === 200) {
          return response.data;
        }
      })
      .then(responseObj => {
        if (responseObj.lastName.toLowerCase() === 'unknown') {
          setUserFullName(`${responseObj.firstName}`);
          setUserNewFullName(`${responseObj.firstName}`);
        } else {
          setUserFullName(`${responseObj.firstName} ${responseObj.lastName}`);
          setUserNewFullName(`${responseObj.firstName} ${responseObj.lastName}`);
        }
      })
      .catch(error => {
        console.log(error);
      });
      
  }, []);
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      className="p-2"
    >
      <Form.Item
        name="name"
        label={t('enter_name')}
        className="apply-job-modal-form-item"
        rules={[
          {
            required: true,
            message: t('enter_name_error'),
          },
        ]}
      >
        <Input
          placeholder={t('your_name')}
          className="apply-job-modal-input"
          defaultValue={userFullName}
          key={userFullName}
          onChange={e => handleChange(e)}
        />
      </Form.Item>

      {['uber'].includes(jobData.companyName.toLowerCase()) && (
        <Form.Item
          name="dlNumber"
          label="DL Number"
          className="apply-job-modal-form-item"
          rules={[
            {
              required: true,
              message: t('dl_empty_error'),
            },
            {
              type: 'string',
              min: 15,
              max: 15,
              message: t('dl_incorrect_error'),
            },
          ]}
        >
          <Input
            placeholder="Your DL Number"
            className="apply-job-modal-input"
            defaultValue={dlNumber}
            key="DlNumber"
            onChange={e => handleDLNumberChange(e)}
          />
        </Form.Item>
      )}

      <Form.Item>
        <Space>
          <BottomButton
            buttonText="Continue"
            callBackFunction={() => applyJob()}
            disabled={disableButton}
            loader={
              buttonLoading ? (
                <LoadingOutlined style={{ fontSize: 24, marginLeft: '1.5em' }} spin />
              ) : null
            }
          />
        </Space>
      </Form.Item>
    </Form>
  );
};

const JobType = ({ jobData }) => {
  return (
    <Tag className="apply-job-modal-tag">
      {jobData?.jobPreference === 'Both Full time and Part time'
        ? 'Full/Part Time'
        : jobData?.jobPreference}
    </Tag>
  );
};

const ApplyJobModal = ({ open, close, jobData, showGetStartedPopup, setSiId, showDuplicateApplicationPopup }) => {
  return (
    <div style={{ position: 'relative' }}>
      <Drawer
          title={<JobFormHeader jobData={jobData} />}
          open={open}
          onClose={close}
          key="applyJob"
          placement="bottom"
          closable={true}
          height="auto" 
        >
          <JobForm 
          jobData={jobData} 
          close={close} 
          showGetStartedPopup={showGetStartedPopup} 
          setSiId={setSiId}
          showDuplicateApplicationPopup={showDuplicateApplicationPopup}
          />
        </Drawer>
      {/* <Modal
        title={<JobFormHeader jobData={jobData} />}
        className="bottom-modal-style apply-job-modal"
        style={{ top: '60%' }}
        closable={false}
        maskClosable
        visible={open}
        onCancel={close}
        footer={null}
        width={500}
      >
        <JobForm jobData={jobData} close={close} />
      </Modal> */}
    </div>
  );
};

export default ApplyJobModal;
